import { useMemo } from "react";
import { useRouteMatch } from "react-router-dom";

export const useMatchedPath = (): string => {
	const { path } = useRouteMatch();

	return useMemo(() => {
		return path;
	}, [path]);
};